import { slugify } from '../constant';
import './IndustriesLayout.scss';

export default function IndustriesLayout({ categories, link, content }) {
  function formatCategoryName(str) {
    return str
      .toLowerCase() // Convert to lowercase
      .replace(/&/g, '') // Remove '&' characters
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/[^a-z0-9-]/g, '') // Remove any other special characters
      .replace(/-+/g, '-') // Replace multiple hyphens with single
      .trim(); // Trim spaces if any
  }

  const renderedColumns = [];
  let skipNext = false;

  categories.forEach((category, idx) => {
    if (skipNext) {
      skipNext = false; // skip the next category as it's already grouped
      return;
    }

    // Single column for 10 or more items
    if (category.items.length >= 6) {
      renderedColumns.push(
        <div className="menu-column" key={idx}>
          <a
            className="menu-title"
            href={`${link}?industry=${formatCategoryName(category.title)}`}>
            {category.title}
          </a>
          <ul className="menu-list">
            {category.items.map((item, i) => (
              <li key={i}>
                <a href={`${item.href}`} className="menu-link">
                  {item.text}
                </a>
              </li>
            ))}
          </ul>
        </div>
      );
      return;
    }

    // Pair categories with less than 10 items
    const nextCategory = categories[idx + 1];
    renderedColumns.push(
      <div className="menu-column" key={idx}>
        {[category, nextCategory].map(
          (cat, subIdx) =>
            cat &&
            cat.items.length < 6 && (
              <div key={subIdx}>
                <a
                  className="menu-title"
                  href={`${link}?industry=${formatCategoryName(cat.title)}`}>
                  {cat.title}
                </a>
                <ul className="menu-list">
                  {cat.items.map((item, i) => (
                    <li key={i}>
                      <a href={`${item.href}`} className="menu-link">
                        {item.text}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )
        )}
      </div>
    );

    if (nextCategory && nextCategory.items.length < 10) {
      skipNext = true; // skip next since it's already rendered
    }
  });

  return (
    <div className="industries-container">
      <div className="menu-grid industries">{renderedColumns}</div>
      <a href={content.view_all.href} className="view-all">
        {content.view_all.text}
      </a>
    </div>
  );
}
